import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {LeafletModule} from '@bluehalo/ngx-leaflet';
import * as Leaflet from 'leaflet';
import {MapService, SimpleGpxDtoRoot} from './map.service';
import {ToastrService} from 'ngx-toastr';

@Component({
  selector: 'app-map',
  imports: [
    LeafletModule
  ],
  templateUrl: './map.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './map.component.scss'
})
export class MapComponent implements OnInit {


  title = 'AngularOSM';

  dynamicOptions: Leaflet.MapOptions = {
    layers: [],
    zoom: 14,
    center: new Leaflet.LatLng(46.8, 13.5)
  };

  constructor(
    private readonly mapService: MapService,
    private readonly notificationService: ToastrService,
  ) {
  }

  ngOnInit(): void {
    this.mapService.getSpecificTracks(this.mapService.listActiveFiles()).subscribe({
      next: res => {
        this.dynamicOptions.layers = this.convertLayersFromBackend(res);
      },
      error: err => this.notificationService.error('failed to retrieve data ' + JSON.stringify(err)),
    });
  }


  private convertLayersFromBackend(gpx: SimpleGpxDtoRoot[]): Leaflet.Layer[] {
    return [
      new Leaflet.TileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {}),
      ...this.getMarkersFromBackend(gpx),
      ...this.getRoutesFromBackend(gpx),
      ];
  }

  private getMarkersFromBackend(gpx: SimpleGpxDtoRoot[]): Leaflet.Marker[] {
    const re:  Leaflet.Marker[] = [];

    gpx.forEach(gpxFile => {
      gpxFile.points.filter(point => this.mapService.ensureWithinLimits(point)).forEach(point => {
        re.push(
          new Leaflet.Marker(new Leaflet.LatLng(point.lat, point.lon), {
            icon: new Leaflet.Icon({
              iconSize: [10, 10],
              iconAnchor: [5, 5],
              iconUrl: 'assets/blue-marker.svg',
            }),
            title: `${gpxFile.name} ${point.time}`,
          })
        );
      });
    });

    return re;
  }

  private getRoutesFromBackend(gpx: SimpleGpxDtoRoot[]): Leaflet.Polyline[] {
    const re: Leaflet.Polyline[] = [];

    gpx.forEach(gpxFile => {
      re.push(this.getRouteOfFile(gpxFile));
    });

    return re;
  }

  private getRouteOfFile(gpxFile: SimpleGpxDtoRoot): Leaflet.Polyline {
    const points: Leaflet.LatLng[] = [

    ];

    gpxFile.points.filter(point => this.mapService.ensureWithinLimits(point)).forEach(point => {
      points.push(new Leaflet.LatLng(point.lat, point.lon));
    });

    return new Leaflet.Polyline(points, {
      // color: '#0d9148'
      color: this.mapService.getFileColor(gpxFile.name),
    });

  }
}
